export const formatLocation = (city, state, country) =>
  `${city ? `${city},` : ''}${state ? ` ${state},` : ''} ${
    country ? ` ${country}` : ''
  }`;
